import React from 'react';

import './styles.css';
const Divider = () => <div className="divider" />;

export default Divider;
